import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import get from 'lodash/get';

import SortSelector from '../SortSelector';
import { getDefaultParams } from '../../../../../utils/urlHelpers/engines';
import { getResultsCount } from '../../../../../utils/paginationHelper';
import './styles.css';

const ResultsHeader = (props) => {
    let pageParams = get(props, 'match.params', {});
    let params = getDefaultParams(pageParams);
    let count = +get(props, 'search.count', 0);

    return (
      <div className="results-header">
        <div className="results-count">
          {getResultsCount(params, count, undefined, undefined, true)}
        </div>
        {!props.isMobile && <SortSelector {...props} />}
      </div>
    );
};

ResultsHeader.propTypes = {
  isMobile: PropTypes.bool
};

export default injectIntl(ResultsHeader);
